module.exports = __webpack_public_path__ + "static/media/man-desktop.c651b938.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/bottom-home-search/man-desktop.png
// module id = 2250
// module chunks = 0